import CubicFeetCalculator from "kinnect-front/Apps/CubicFeetCalculator";
import FullWidthLayout from "@/layouts/FullWidthLayout";
import { Pageable } from "kinnect-mixins";

export default {
	name: "CubicFeetCalculatorPage",

	metaInfo: { title: "Apps - Cubic Feet Calculator" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<CubicFeetCalculator></CubicFeetCalculator>
		</FullWidthLayout>;
	}
};
